export default __webpack_public_path__ + "static/media/medalha-bronze.909dfaed.svg";